import { useCallback, useMemo } from "react";

import { useRouter } from "next/router";

import { useQueryClient } from "@tanstack/react-query";

import { useQueryCashed } from "@/hooks/useQueryCashed";

import { LadyProfileApi } from "../api";

type QueryData = Awaited<ReturnType<typeof LadyProfileApi.getInfo>>;
type MediaType = NonNullable<QueryData>["forms"]["media"][number]["type"];
type ToggleMediaParams = { objectId: number; mediaType: MediaType };
export type LadyDtoToggleMediaFavorite = (params: ToggleMediaParams) => void;

export const useLadyProfileDto = () => {
  const router = useRouter();
  const objectId = router.query["lady-id"];
  const queryClient = useQueryClient();

  const queryKey = useMemo(
    () => ["LADY_PROFILE", { objectId }] as const,
    [objectId],
  );

  const queryCachedValue = useQueryCashed({
    queryKey,
    queryFn: async () => {
      return LadyProfileApi.getInfo({ objectId });
    },
    enabled: !!objectId,
  });

  const toggleMediaFavorite = useCallback<LadyDtoToggleMediaFavorite>(
    ({ objectId, mediaType }) => {
      const data = queryClient.getQueryData<QueryData>(queryKey);

      if (!data) return;

      const updatedMedia = data.forms.media.map((item) => {
        if (
          item.type === "photo" &&
          item.type === mediaType &&
          item.photoId === objectId
        ) {
          return { ...item, isFavorite: !item.isFavorite };
        }

        if (
          item.type === "intro_video" &&
          item.type === mediaType &&
          item.id === objectId
        ) {
          return { ...item, isFavorite: !item.isFavorite };
        }

        return item;
      });

      queryClient.setQueryData(queryKey, () => ({
        ...data,
        forms: {
          ...data.forms,
          media: updatedMedia,
        },
      }));
    },
    [queryClient, queryKey],
  );

  return { ...queryCachedValue, clientMutations: { toggleMediaFavorite } };
};

export const useLadyVideoDto = (id?: number) => {
  return useQueryCashed({
    queryKey: ["LADY_PROFILE_VIDEOS", { id }],
    queryFn: async () => {
      // return LadyProfileApi.getVideos(id);
    },
  });
};
